import React from "react";
import "./SappmPage.css";

const CONVICTIONS = [
    {
        title: "Le service public n'est pas un sacrifice.",
        body: "Servir l'État ne doit jamais vouloir dire se taire, s'effacer, s'épuiser en silence. Une administration forte est une administration où l'on peut dire ce qui va mal sans craindre pour son poste, sa carrière, ou sa santé.",
    },
    {
        title: "L'intérêt général commence par les personnes.",
        body: "On ne défend pas des dossiers. On défend des collègues — avec leur nom, leur histoire, leurs 40 heures par semaine données à une mission qui les dépasse parfois. Un syndicat qui oublie l'humain derrière le statut a déjà perdu sa raison d'être.",
    },
    {
        title: "La dignité n'est pas négociable.",
        body: "Harcèlement, mise à l'écart, déni de souffrance : ce ne sont pas des \"sujets RH\". Ce sont des atteintes à ce que l'État doit incarner. Nous ne transigeons pas là-dessus.",
    },
    {
        title: "Le silence protège rarement celui qui se tait.",
        body: "Beaucoup d'agents pensent qu'il faut choisir entre se protéger et parler. Nous pensons l'inverse : c'est en étant accompagné, informé, soutenu, que l'on retrouve la force de dire — et que les choses changent vraiment.",
    },
];

export default function SappmPage({onBack}) {
    return (
        <div className="sappm-page">
            <div className="sappm-wrapper">
                {onBack && (
                    <button className="sappm-btn-back" onClick={onBack}>← Retour à la page d'accueil</button>
                )}

                <h1 className="sappm-title">
                    On vous a appris à servir l'intérêt général. Personne ne vous a dit qui veillerait sur le vôtre ?
                </h1>

                <p className="sappm-intro">
                    S'il est vrai que l'administration doit protéger ses agents contre les menaces, violences, voies de fait, injures, diffamations ou outrages dont ils pourraient être victimes à l'occasion de leurs fonctions, et réparer le cas échéant le préjudice qui en résulte (article L. 134-1 du Code général de la fonction publique), qu'en est-il aujourd'hui, comment cette obligation se concrétise face aux nouveaux défis de notre société ?
                </p>

                <hr className="sappm-divider"/>

                <h2 className="sappm-section-title">Ce que nous croyons</h2>
                <div className="sappm-convictions">
                    {CONVICTIONS.map(c => (
                        <div key={c.title} className="sappm-conviction">
                            <p className="sappm-conviction-title">{c.title}</p>
                            <p className="sappm-conviction-body">{c.body}</p>
                        </div>
                    ))}
                </div>

                <hr className="sappm-divider"/>

                <h2 className="sappm-section-title">Pourquoi ça vous concerne, même si tout va bien aujourd'hui</h2>
                <p className="sappm-paragraph">
                    Vous n'avez pas besoin d'aller mal pour avoir besoin de nous. Le SAPPM, c'est un filet — pour le jour où une décision vous semblera injuste, où un collègue craquera à côté de vous, où vous vous demanderez si ce que vous vivez au travail est normal.
                </p>
                <p className="sappm-paragraph sappm-paragraph--bold">
                    <strong>Nous sommes là avant que ça n'aille mal. Et surtout, nous restons là quand ça va mal.</strong>
                </p>

                <p className="sappm-signature">
                    Le SAPPM — Syndicat Autonome des Personnels des Services du Premier Ministre. Parce qu'un service rendu à l'intérêt général mérite d'être rendu par des agents qui vont bien.
                </p>
            </div>
        </div>
    );
}
